import type {Router, RouteRecordRaw} from 'vue-router';
import {createRouter, createWebHistory} from 'vue-router';

import {keycloakAPI} from '@/assets/keycloak';

import {standaloneState} from '@/services/state/standalone';

import {adminRoutes} from '@/app/admin/router';

export let router: Router | undefined = undefined;
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'BasePage',
    redirect: '/entry',
    component: () => import('@/pages/unit/BasePage.vue'),
    children: [
      {
        path: 'not_found/',
        name: 'NotFoundPage',
        component: () => import('../pages/unit/NotFoundPage.vue'),
      },
      {
        path: 'entry/',
        name: 'EntryListPage',
        component: () => import('../pages/EntryListPage.vue'),
      },
      {
        path: 'form',
        name: 'FormListPage',
        component: () => import('../pages/FormListPage.vue'),
      },
      {
        path: 'form/:form_id',
        name: 'FormPage',
        component: () => import('../pages/FormPage.vue'),
      },
      {
        path: 'form/:form_id/entry/:entry_id',
        name: 'EntryPage',
        component: () => import('../pages/FormPage.vue'),
      },
      {
        path: '/preview/:id',
        name: 'PreviewPage',
        component: () => import('../pages/PreviewPage.vue'),
      },
      // {
      //   path: '/frame/:id',
      //   name: 'FramePage',
      //   component: () => import('../pages/FramePage.vue'),
      // },
      ...adminRoutes,
    ],
  },
];

export const getRouter = () => router as Router;
export const initRouter = () => {
  router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
  });

  router.beforeEach(async (to, from, next) => {
    if (!keycloakAPI.getIsInit.value) await keycloakAPI.init();

    standaloneState.initFromQuery(to.query);

    if (standaloneState.isStandalone.value && to.query.standalone !== 'true') {
      next({
        ...to,
        query: {...to.query, standalone: 'true'},
        replace: true,
      });
      return;
    }

    if (to.matched.length) next();
    else next({path: 'not_found'});
  });

  return router;
};
